import { Box, Image, useToast } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import BellActive from '../../assets/icons/BellActive.svg';
import BellInactive from '../../assets/icons/BellInactive.svg';
import { AuthenticatedComponent } from '../../auth/keycloak';
import NotificationContext from '../../context/NotificationContext';
import PageDataContext from '../../context/PageDataContext';
import { FCMToken } from '../../firebase/messaging';
import { usePageDataCache } from '../../hooks/usePageDataCache';
import {
    isSubscribedToNotifications,
    subscribeToNotificationTopic,
    unsubscribeFromNotificationTopic,
} from '../../service/social';

interface NotificationToggleProps {
    streamSixIDText: string;
}

export const NotificationToggle: AuthenticatedComponent<NotificationToggleProps> = ({
    streamSixIDText,
    keycloak,
}) => {
    const { isLoadFromCache } = useContext(PageDataContext);
    const localStoragePrefix = `NotificationToggle_${streamSixIDText}`;

    const toast = useToast();

    const [isOn, setIsOn] = usePageDataCache(`${localStoragePrefix}_isOn`, false);
    const { isNotificationSetup } = useContext(NotificationContext);

    useEffect(() => {
        if (isNotificationSetup) {
            const checkIfSubscribed = async () => {
                const token = keycloak.token;
                const myUserID = keycloak.subject;
                const subscribed = await isSubscribedToNotifications(
                    token,
                    FCMToken,
                    myUserID,
                    `Live_${streamSixIDText}`,
                );
                setIsOn(subscribed);
            };
            if (!isLoadFromCache) {
                checkIfSubscribed();
            }
        }
    }, [isNotificationSetup, streamSixIDText]);

    const handleToggle = async () => {
        if (!isNotificationSetup) {
            toast({
                title:
                    Notification.permission !== 'granted'
                        ? 'Notifications Disabled'
                        : 'Something Went Wrong',
                description:
                    Notification.permission !== 'granted'
                        ? 'Please enable notifications to use this feature'
                        : 'An error occurred please try again',
                status: 'error',
                duration: 9000,
                isClosable: true,
            });
            return;
        }

        const token = keycloak.token;
        const userID = keycloak.subject;

        if (isOn) {
            const success = await unsubscribeFromNotificationTopic(
                token,
                FCMToken,
                userID,
                `Live_${streamSixIDText}`,
            );
            if (success === null) {
                return;
            }
        } else {
            const success = await subscribeToNotificationTopic(
                token,
                FCMToken,
                userID,
                `Live_${streamSixIDText}`,
            );
            if (success === null) {
                return;
            }
        }
        setIsOn(!isOn);
    };

    return (
        <Box className={'notification-box'}>
            {isOn ? (
                <Image src={BellActive} onClick={handleToggle} cursor={'pointer'} />
            ) : (
                <Image src={BellInactive} onClick={handleToggle} cursor={'pointer'} />
            )}
        </Box>
    );
};
